import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_MWTW_TITLE]: 'More Purchase Options',
  [StringId.DV_MWTW_TITLE_MAIN]: 'More Purchase {conditionalLineBreak}Options'
}
